module.exports = {
  API_URL: 'https://imengagement.intermiles.com/api',
  domain: 'https://uat.intermiles.com',
  currentEnv: 'uat',

  //Keycloak configs
  keycloakDomain: 'https://sso-dev.intermiles.com',
  realm: 'InterMiles',
  keycloakCId: '3ZWRiu4NUtMMBJEtp4jXrs9jDTlXcO7V',
};
